import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './PreApprovedTemplates.html';
import { PreApprovedTemplateFilterModel, PreApprovedTemplateModel } from './PreApprovedTemplateModel';
import PreApprovedTemplateService from './PreApprovedTemplateService';
import { Toaster } from '../../Services/toast';
import UserService from '../../shared/userService/UserService';
import UserRoleService from '../../shared/userService/UserRoleService';
import { DropdownModel } from '../Provider/ProviderModel';

@WithRender
@Component({
    components: {},
    diProvide: [
        PreApprovedTemplateService,
        UserService,
        UserRoleService,
    ],
})
export default class PreApprovedTemplates extends Vue {
    @Inject(PreApprovedTemplateService) public preApprovedTemplateService!: PreApprovedTemplateService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    public deleteDialog: boolean = false;
    public previewDialog: boolean = false;
    public templateIdToDelete: string = '';
    public previewContent: string = '';

    public createdDateFromMenu: boolean = false;
    public createdDateToMenu: boolean = false;

    public templates: PreApprovedTemplateModel[] = [];
    public totalCount: number = 0;
    public User: any;
    public userRole: any;

    public filterModel: PreApprovedTemplateFilterModel = {
        name: '',
        classification: null,
        createdDateFrom: '',
        createdDateTo: '',
    };

    public classificationList: DropdownModel[] = [];
    public headers: any[] = [];

    public created() {
        this.classificationList = [
            { id: 1, name: this.$t('shared.Advertising').toString() },
            { id: 2, name: this.$t('shared.Service').toString() },
            { id: 3, name: this.$t('shared.Warning').toString() },
            { id: 5, name: this.$t('shared.Awareness').toString() },
        ];
        this.headers = [
            { text: this.$t('shared.templateId').toString(), value: 'templateCode', align: 'center', sortable: false },
            { text: this.$t('shared.templateName').toString(), value: 'name', align: 'center', sortable: false },
            { text: this.$t('shared.classification').toString(), value: 'classification', align: 'center', sortable: false },
            { text: this.$t('shared.createdDate').toString(), value: 'createdDate', align: 'center', sortable: false },
            { text: this.$t('shared.contentPreview').toString(), value: 'templateContent', align: 'center', sortable: false },
            { text: this.$t('shared.status').toString(), value: 'isActive', align: 'center', sortable: false },
            { text: this.$t('shared.actions').toString(), value: 'actions', align: 'center', sortable: false, width: '120' },
        ];
    }
    public Details(id: string) {
        if (!id) return;
        this.$router.push({ name: 'PreApprovedTemplateInfo', params: { id } });
    }
    public async mounted() {
        this.User = await this.userService.getUser();
        this.userRole = this.GetUserRole();
        this.$emit('childinit', this.layoutSup);
    }

    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }

    @Watch('filterModel.name')
    public async onNameFilterChanged() {
        await this.load();
    }

    public async onClassificationChanged() {
        await this.load();
    }

    public async onDateChange(type: string) {
        if (type === 'from') {
            this.createdDateFromMenu = false;
        } else if (type === 'to') {
            this.createdDateToMenu = false;
        }
        await this.load();
    }

    public async resetFilter() {
        this.filterModel = {
            name: '',
            classification: null,
            createdDateFrom: '',
            createdDateTo: '',
        };
        await this.load();
    }

    private processTemplates(templates: any[]): any[] {
        if (!templates) return [];
        return templates.map((template: any) => {
            if (template.templateContent) {
                try {
                    const parsedData = JSON.parse(template.templateContent);
                    template.templateContent = parsedData.text || '';
                } catch (e) {
                }
            }
            return template;
        });
    }

    public async load() {
        const response = await this.preApprovedTemplateService.get(this.filterModel, '0', '10');
        if (!response || !response.isSuccess) {
            Toaster.error((response && response.errorMessage) || this.$t('shared.loadFailed').toString());
            this.templates = [];
            this.totalCount = 0;
            return;
        }
        this.templates = this.processTemplates(response.result);
        this.totalCount = response.totalCount || 0;
    }

    public async updatePaginate(val: any) {
        const response = await this.preApprovedTemplateService.get(
            this.filterModel,
            (val.page - 1).toString(),
            val.rowsPerPage);
        if (!response || !response.isSuccess) {
            Toaster.error((response && response.errorMessage) || this.$t('shared.loadFailed').toString());
            return;
        }
        this.templates = this.processTemplates(response.result);
        this.totalCount = response.totalCount || 0;
    }

    public async toggleActivation(item: any) {
        if (!item || !item.id) return;

        const response = await this.preApprovedTemplateService.activate(item.id);

        if (response && response.isSuccess) {
            const messageKey = item.isActive ? 'shared.activatedSuccessfully' : 'shared.deactivatedSuccessfully';

            Toaster.success(this.$t(messageKey).toString());        } else {
            Toaster.error(response.errorMessage || this.$t('shared.saveFailed').toString());
            item.isActive = !item.isActive;
        }
    }

    public classificationLabel(classification: number): string {
        const item = this.classificationList.find((c) => c.id === classification);
        return item ? item.name : String(classification);
    }

    public formatDate(dateValue: string): string {
        if (!dateValue) {
            return '';
        }
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) {
            return dateValue;
        }
        return date.toLocaleDateString('en-GB').replace(/\//g, '-');
    }
}